/** Unit price from vendor cost + markup percentage, rounded half-up to cents. */
export function priceFromCost(cost: number, markupPct: number): number {
  return Math.round(cost * (1 + markupPct / 100) * 100) / 100;
}

/** Implied markup % (1 decimal) from cost + typed price; null when cost is not positive. */
export function markupFromPrice(cost: number, price: number): number | null {
  if (!(cost > 0)) return null;
  return Math.round((price / cost - 1) * 100 * 10) / 10;
}
